(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["circle-curated-grid"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('e-circle-catalog')) {
    customElements.define('e-circle-catalog', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const checkbox = this.querySelector('[data-circle-available]');
        const pieces = Array.from(this.querySelectorAll('[data-circle-piece]'));
        const update = () => {
          pieces.forEach(piece => { piece.hidden = checkbox.checked && piece.dataset.available !== 'true'; });
        };
        checkbox.addEventListener('change', update);
        this.querySelector('[data-circle-filter]').hidden = false;
        update();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
